import React, { useState } from "react";
import { Routes, Route, r, Navigate } from "react-router-dom";
import Layout from "../Components/share/layout/Layout";
import DashboardLayout from "../Components/share/layout/DashboardLayout";
import Home from "../Layouts/MainPart/Home/Home";
import Price from "../Layouts/MainPart/Price/Price";
import Dashboard from "../Components/layouts/dashboard/Dashboard";
import BootCamps from "../Layouts/MainPart/bootcamps/BootCamps";
import Options from "../Components/layouts/option/Options";
import AboutUs from "../Components/layouts/aboutus/AboutUs";
import SupportTicket from "../Layouts/Admin Dashboard/SupportTicket";
import Message from "../Layouts/Admin Dashboard/Message";
import Notifications from "../Layouts/Admin Dashboard/Notifications";
import CreatedBootcamps from "../Components/layouts/CreatedBootcamps/CreatedBootcamps";
import CreateCourseLayout from "../Layouts/CreateCourse/CreateCourseLayout";
import CourseDashboardLayout from "../Components/share/layout/CourseDashboardLayout";
import StudentDashboard from "../Components/share/layout/StudentDashboard";
import StudentCourse from "../Components/share/layout/StudentCourse";
import SessionsMain from "../Components/layouts/AdminDashboard/SessionsMain";
import GeneralInfo from "../Components/layouts/AdminDashboard/GeneralInfo";
import {
    FaGraduationCap,
    FaRegUserCircle,
    FaRegBookmark,
} from "react-icons/fa";
import { BiWallet, BiCommentDetail } from "react-icons/bi";
import { BsSun } from "react-icons/bs";
import { HiOutlineTicket } from "react-icons/hi";
import { IoIosNotificationsOutline } from "react-icons/io";
import {
    AiOutlineMessage,
    AiOutlineInfoCircle,
    AiOutlineLike,
    AiOutlineTeam,
    AiOutlineDesktop,
    AiOutlineBell,
    AiOutlineFileText,
    AiOutlineSafetyCertificate,
} from "react-icons/ai";
import { VscHome } from "react-icons/vsc";
import { useLocation } from "react-router-dom";
import Ticket from "../Layouts/Ticket/Ticket";
import MyBootCamp from "../Layouts/Student/Student Dashboard/MyBootCamp";
import StudentDash from "../Layouts/Student/Student Dashboard/Dashboard";
import SaveBootCamp from "../Layouts/Student/Student Dashboard/SaveBootCamp";
import StudentSupportTicket from "../Layouts/Student/Student Dashboard/StudentSupportTicket";
import Systemnotifications from "../Layouts/Student/Student Dashboard/Systemnotifications";
import BootCamp from "../Layouts/Student/Student Course/BootCamp";
import Idea from "../Layouts/Student/Student Course/Idea";
import Priority from "../Layouts/Student/Student Course/Priority";
import Myteam from "../Layouts/Student/Student Course/Myteam";
import Meeting from "../Layouts/Student/Student Course/Meeting";
import Poll from "../Layouts/Student/Student Course/Poll";
import StudentMessage from "../Layouts/Student/Student Course/StudentMessage";
import StudentFiles from "../Layouts/Student/Student Course/StudentFiles";
import Adminmessage from "../Layouts/Admin Course/Adminmessage";
import Arbitration from "../Layouts/Admin Course/Arbitration";
import Document from "../Layouts/Admin Course/Document";
import Survey from "../Layouts/Admin Course/Survey";
import Files from "../Layouts/Admin Course/Files";
import Teams from "../Layouts/Admin Course/Teams";
import Finance from "../Components/layouts/StudentDashboard/Finance";
import Profile from "../Components/layouts/StudentDashboard/Profile";
import Documents from "../Layouts/Student/Student Course/Documents";
import Results from "../Layouts/Student/Student Course/Results";
import Homepage from "../Pages/Homepage";
import BootcampsPage from "../Pages/BootcampsPage";
import FeaturesPage from "../Pages/FeaturesPage";
import PriceCalculationPage from "../Pages/PriceCalculationPage";
import AboutPage from "../Pages/AboutPage";
import TestPage from "../Pages/TestPage";
import OffSection from "../Components/layouts/AdminDashboard/OffSection";
import Rolles from "../Layouts/Admin Course/Rolles";
import AdminIdea from "../Layouts/Admin Course/AdminIdea";
import AdminPriority from "../Layouts/Admin Course/AdminPriority";
import StudentFinance from "../Components/layouts/StudentDashboard/StudentFinance";

function Router(props) {
    const location = useLocation();

    return (
        <Routes location={location}>
            <Route element={<Layout />}>
                <Route path="/" element={<Homepage />} />
                <Route path="/bootcamp" element={<BootcampsPage />} />
                <Route path="/options" element={<FeaturesPage />} />
                <Route path="/price" element={<PriceCalculationPage />} />
                <Route path="/aboutus" element={<AboutPage />} />
                <Route path="/test" element={<TestPage />} />
            </Route>

            {/* dashboard -  داشبورد ادمین */}
            <Route
                path="/dashboard"
                element={<DashboardLayout menu={menu} type="admin" />}
            >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                    path="/dashboard/bootcamps"
                    element={<CreatedBootcamps />}
                />
                <Route path="/dashboard/profile" element={<Profile />} />
                <Route path="/dashboard/finance" element={<Finance />} />
                <Route
                    path="/dashboard/Support-ticket"
                    element={<SupportTicket />}
                />

                <Route path="/dashboard/sponsors" element={<Message />} />
                <Route
                    path="/dashboard/Systemnotifications"
                    element={<Notifications />}
                />
                <Route path="/dashboard/sessions" />
            </Route>

            {/* student dashboard - داشبورد دانشجو */}
            <Route
                path="/studentdashboard"
                element={<StudentDashboard menu={menustudent} type="student" />}
            >
                <Route path="/studentdashboard" element={<StudentDash />} />
                <Route
                    path="/studentdashboard/bootcamp"
                    element={<MyBootCamp />}
                />
                <Route
                    path="/studentdashboard/savebootcamp"
                    element={<SaveBootCamp />}
                />
                <Route
                    path="/studentdashboard/supportticket"
                    element={<StudentSupportTicket />}
                />
                <Route
                    path="/studentdashboard/Systemnotifications"
                    element={<Systemnotifications />}
                />
                <Route
                    path="/studentdashboard/finance"
                    element={<StudentFinance />}
                />
                <Route path="/studentdashboard/profile" element={<Profile />} />
            </Route>

            {/* student course - داشبورد دوره دانشجو */}
            <Route
                path="/studentcourse"
                element={
                    <StudentCourse
                        menu={menustudentcourse}
                        type="student"
                        {...props}
                        location={location}
                    />
                }
            >
                <Route path="/studentcourse" element={<BootCamp />} />
                <Route path="/studentcourse/bootcamp" element={<BootCamp />} />
                <Route path="/studentcourse/idea" element={<Idea />} />
                <Route
                    path="/studentcourse/documents"
                    element={<Documents />}
                />
                <Route path="/studentcourse/priority" element={<Priority />} />
                <Route path="/studentcourse/results" element={<Results />} />
                <Route path="/studentcourse/myteam" element={<Myteam />} />
                <Route path="/studentcourse/meeting" element={<Meeting />} />
                <Route path="/studentcourse/poll" element={<Poll />} />
                <Route path="/studentcourse/files" element={<StudentFiles />} />
            </Route>

            {/* course dashboard - داشبورد دوره‌ی ادمین */}
            <Route
                path="/coursedash"
                element={
                    <CourseDashboardLayout {...props} location={location} />
                }
            >
                <Route path="/coursedash" element={<GeneralInfo />} />
                <Route
                    path="/coursedash/generalinfo"
                    element={<GeneralInfo />}
                />
                <Route path="/coursedash/sections" element={<SessionsMain />} />
                <Route path="/coursedash/tickets" element={<Ticket />} />
                <Route path="/coursedash/off" element={<OffSection />} />
                <Route path="/coursedash/idea" element={<AdminIdea />} />
                <Route
                    path="/coursedash/priority"
                    element={<AdminPriority />}
                />
                <Route path="/coursedash/roles" element={<Rolles />} />
                <Route path="/coursedash/teams" element={<Teams />} />
                <Route path="/coursedash/file" element={<Files />} />
                <Route path="/coursedash/survey" element={<Survey />} />
                <Route path="/coursedash/document" element={<Document />} />
                <Route
                    path="/coursedash/arbitration"
                    element={<Arbitration />}
                />
                <Route
                    path="/coursedash/adminmessage"
                    element={<Adminmessage />}
                />
                <Route
                    path="/coursedash/*"
                    element={<Navigate to="/coursedash/generalinfo" replace />}
                />
            </Route>

            {/* create course - ساخت دوره‌ */}
            <Route path="/create" element={<CreateCourseLayout />} />
        </Routes>
    );
}

export default Router;

const menu = [
    {
        title: " بوت کمپ‌های ساخته شده",
        icon: <FaGraduationCap />,
        link: "/dashboard/bootcamps",
    },
    {
        title: " پروفایل",
        icon: <FaRegUserCircle />,
        link: "/dashboard/profile",
    },
    {
        title: " امور مالی",
        icon: <BiWallet />,
        link: "/dashboard/finance",
    },
    {
        title: "برگزارکنندگان",
        icon: <AiOutlineSafetyCertificate />,
        link: "/dashboard/sponsors",
    },
    {
        title: "تیکت پشتیبانی",
        icon: <HiOutlineTicket />,
        link: "/dashboard/Support-ticket",
    },
    {
        title: "اعلانات سیستمی",
        icon: <IoIosNotificationsOutline />,
        link: "/dashboard/Systemnotifications",
    },
    {
        title: "صفحه اصلی سایت",
        icon: <VscHome />,
        link: "/",
    },
];
const menustudent = [
    {
        title: "بوت کمپ های من",
        icon: <FaGraduationCap />,
        link: "/studentdashboard/bootcamp",
    },
    {
        title: "بوت کمپ های ذخیره شده",
        icon: <FaRegBookmark />,
        link: "/studentdashboard/savebootcamp",
    },
    {
        title: "امور مالی",
        icon: <BiWallet />,
        link: "/studentdashboard/finance",
    },
    {
        title: "پروفایل",
        icon: <FaRegUserCircle />,
        link: "/studentdashboard/profile",
    },
    {
        title: "تیکت پشتیبانی",
        icon: <HiOutlineTicket />,
        link: "/studentdashboard/supportticket",
    },
    {
        title: "اعلانات سیستمی",
        icon: <IoIosNotificationsOutline />,
        link: "/studentdashboard/Systemnotifications",
    },
    {
        title: "صفحه اصلی سایت",
        icon: <VscHome />,
        link: "/",
    },
];
const menustudentcourse = [
    {
        title: "اطلاعات کلی بوت کمپ",
        icon: <AiOutlineInfoCircle />,
        link: "/studentcourse/bootcamp",
    },
    {
        title: "ایده ها",
        icon: <BsSun />,
        link: "/studentcourse/idea",
    },
    {
        title: "اولویت ها",
        icon: <AiOutlineLike />,
        link: "/studentcourse/priority",
    },
    {
        title: "جلسات",
        icon: <AiOutlineDesktop />,
        link: "/studentcourse/meeting",
    },
    {
        title: "تیم من",
        icon: <AiOutlineTeam />,
        link: "/studentcourse/myteam",
    },
    {
        title: "فایل ها",
        icon: <AiOutlineFileText />,
        link: "/studentcourse/files",
    },
    {
        title: "نظرسنجی",
        icon: <BiCommentDetail />,
        link: "/studentcourse/poll",
    },
    {
        title: "مدارک",
        icon: <VscHome />,
        link: "/studentcourse/documents",
    },
    {
        title: "نتایج",
        icon: <VscHome />,
        link: "/studentcourse/results",
    },
    {
        title: "بازگشت به پیشخوان اصلی",
        icon: <VscHome />,
        link: "/studentcourse",
    },
];
